import {connect} from 'react-redux';
import {
    QCSnapshot,
    resetSnapshotsAction,
    deleteSnapshotAction,
    DeleteSnapshotAction,
} from './Redux/SnapshotActions';
import SnapshotContainer from './SnapshotContainer';
import {Item, Video} from '../../QCMedia/Redux/QCMediaActions';

export interface QCSnapshots {
    snapshots: QCSnapshot[];
}

interface StateProps {
    qcSnapshots: QCSnapshots;
    video: Video
}

export type State = {
    videoAudioQC: {
        qcSnapshots: QCSnapshots,
        qcMedia: {
            item: Item
        }
    };
};

export const mapState = (state: State): StateProps => {
    const {
        qcSnapshots,
        qcMedia,
    } = state.videoAudioQC;

    const {
        item
    } = qcMedia;

    const {
        video
    } = item;

    return {
        qcSnapshots,
        video,
    };
};

export const mapDispatch = {
    resetSnapshots: resetSnapshotsAction,
    deleteSnapshot: deleteSnapshotAction as DeleteSnapshotAction,
}

export default connect(mapState, mapDispatch)(SnapshotContainer);

